"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMobile = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const SignInLink_1 = require("./SignInLink");
const SignInMobileTray_1 = require("./SignInMobileTray");
const UserIconDisplayName_1 = require("./UserIconDisplayName");
const Styled = styled_components_1.default.div `
	cursor: pointer;
	a {
		padding: 16px 12px;
	}

	i {
		margin: 0 4px;
	}

	span.user-label {
		top: -3px;
		position: relative;
		white-space: nowrap;
	}

	position: absolute;
	left: 0;
	width: calc(100% - ${(p) => p.theme.navHeight * 2}px);
	${(p) => p.theme.breakpoints.down("xs")} {
		width: calc(100% - ${(p) => p.theme.navHeight}px);
	}

	&.no-locale {
		width: 100%;
		${(p) => p.theme.breakpoints.down("xs")} {
			width: 100%;
		}
	}
`;
const AccountMobile = (props) => {
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    const { menuOpen, setMenuOpen } = (0, shared_1.useSignInMobileTray)();
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setMenuOpen, SignInMobileTray_1.signInMobileMenuId);
    const onKeyUp = (0, shared_1.useHandleKeyUp)(toggleMenu);
    const { displayName, isLoggedIn, accountLinks = {}, hide, hideLocale } = props;
    const { signInLinks = [] } = accountLinks;
    const signInDropdown = (signInLinks === null || signInLinks === void 0 ? void 0 : signInLinks.length) && signInLinks.length > 1;
    const firstSignInLink = signInLinks[0] || (0, utils_1.defaultSignInLink)();
    const directSignIn = (0, react_1.useCallback)(() => {
        (0, epic_games_nav_shared_1.navigateWithHref)(firstSignInLink.href, locale);
    }, [firstSignInLink, locale]);
    const onKeyUpDirect = (0, shared_1.useHandleKeyUp)(directSignIn);
    if (hide)
        return null;
    const className = hideLocale ? "no-locale" : "";
    if (!isLoggedIn) {
        if (signInDropdown) {
            return (react_1.default.createElement(Styled, { role: "menu", className: className, onClick: toggleMenu, onKeyUp: onKeyUp },
                react_1.default.createElement(SignInLink_1.SignInLink, null)));
        }
        else {
            return (react_1.default.createElement(Styled, { role: "menu", className: className, onClick: directSignIn, onKeyUp: onKeyUpDirect },
                react_1.default.createElement(SignInLink_1.SignInLink, { href: firstSignInLink.href })));
        }
    }
    return (react_1.default.createElement(Styled, { role: "menu", className: className, onClick: toggleMenu, onKeyUp: onKeyUp },
        react_1.default.createElement(UserIconDisplayName_1.UserIconDisplayName, { displayName: displayName })));
};
exports.AccountMobile = AccountMobile;
//# sourceMappingURL=AccountMobile.js.map